import { Icon, IconName } from "@silversea-ssc/ui-components-react"
import React, { ReactElement } from "react"
import styles from "./SidebarBoxContent.module.scss"

type Props = {
    iconName: IconName
    button?: ReactElement
    dataContentName: string
    tag?: ReactElement
}

const SidebarBoxContent: React.FC<React.PropsWithChildren<Props>> = ({
    dataContentName,
    children,
    iconName,
    button,
    tag,
}) => {
    return (
        <div className={styles.container} data-content-name={dataContentName}>
            {tag && <div className={styles.tag}>{tag}</div>}
            <div className={styles.content}>
                <Icon name={iconName} size="2x" padding="inline" className={styles.icon} />
                <span>{children}</span>
            </div>
            {button && <div className={styles.button}>{button}</div>}
        </div>
    )
}

export default SidebarBoxContent
